<img [src]="src || placeholderSrc"
  [srcset]="srcset"
  [sizes]="sizes"
  [alt]="alt ?? null"
  [attr.loading]="nativeLazy ? 'lazy' : 'eager'"
  [attr.aria-hidden]="ariaHidden ? 'true' : null"
  [ngStyle]="imgStyle">